import { render, staticRenderFns } from "./ReStrangeDateRange.vue?vue&type=template&id=b90ba296&scoped=true"
import script from "./ReStrangeDateRange.vue?vue&type=script&lang=js"
export * from "./ReStrangeDateRange.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b90ba296",
  null
  
)

export default component.exports